import { date, object, ref, string } from 'yup';

export const passwordSchema = object().shape({
  currentPassword: string().required('Password is required'),
  // .matches(
  //   /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[A-Za-z\d]{8,}$/,
  //   'Password must contain at least 8 characters with one uppercase letter, one lowercase letter, and one number. No special characters allowed.',
  // ),
  confirmNewPassword: string()
    .required('Password is required')
    .matches(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[A-Za-z\d]{8,}$/,
      'Password must contain at least 8 characters with one uppercase letter, one lowercase letter, and one number. No special characters allowed.',
    ),
  newPassword: string()
    .required('Password is required')
    .matches(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[A-Za-z\d]{8,}$/,
      'Password must contain at least 8 characters with one uppercase letter, one lowercase letter, and one number. No special characters allowed.',
    ),
});

export const translationScheme = object().shape({
  translationKey: string().required('Translation key is required'),
  en: string().required('Content is required'),
  fr: string(),
});

export const PASSWORD_RULES = {
  password: string().required('This Field is required'),
  confirmPassword: string()
    .nullable()
    .required('This Field is required')
    .oneOf([ref('password')], 'Passwords must match'),
};

export const userValidationScheme = object().shape({
  firstName: string().required('This Field is required'),
  lastName: string().required('This Field is required'),
  email: string()
    .email('Please write valid email')
    .required('This Field is required'),
  phoneNumber: string().required('This Field is required'),
  dateOfBirth: date().required('This Field is required'),
  licensePermitDate: date().required('This Field is required'),
  licenseNumber: string().required('This Field is required'),
  passport: string().required('This Field is required'),
  proofOfAddressDoc: string().required('This Field is required'),
  drivingLicense: string().required('This Field is required'),
});

export const contactUsScheme = object().shape({
  firstName: string().required(),
  lastName: string().required(),
  senderEmail: string().email('Please write valid email').required(),
  subject: string().required(),
  message: string().required(),
});

export const checkoutFormScheme = object().shape({
  cardholderName: string().required(),
  cardNumber: string().required(),
  expirationMonth: date().required(),
  expirationYear: date().required(),
  cvc: string().required(),
});

export const upcomingActionsValidationScheme = object().shape({
  date: date().required('This Field is required'),
  title: string().required('This Field is required'),
});
